import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseActivityEntity } from './activity-history/base-activity.entity';
import type { SourcingRequestEntity } from './sourcing-request.entity';

@Index('idx_sra_sr_created', ['fkSourcingRequestId', 'createdDate'], {})
@Index('idx_sra_type', ['activityType'], {})
@Index('idx_sra_user', ['fkUserId'], {})
@Entity('sourcing_request_activity')
export class SourcingRequestActivityEntity extends BaseActivityEntity {
	@Column('int', { name: '_fk_sourcing_request__id', unsigned: true })
	public fkSourcingRequestId!: number;

	@ManyToOne('SourcingRequestEntity', 'activities', {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([
		{ name: '_fk_sourcing_request__id', referencedColumnName: 'id' },
	])
	public fkSourcingRequest!: SourcingRequestEntity;
}
